import { cn } from '@/lib/utils';
import type { ResetCounts, ResetResult } from '@/types';

const countRows: Array<{ key: keyof ResetCounts; label: string }> = [
  { key: 'sessions', label: 'Sessions' },
  { key: 'sessionMessages', label: 'Messages' },
  { key: 'sessionCardEvents', label: 'Card events' },
  { key: 'memories', label: 'Memories' },
  { key: 'storyCardProgress', label: 'Story-card progress' },
  { key: 'mastraThreadsDeleted', label: 'Mastra threads' },
  { key: 'workingMemoryCleared', label: 'Working memory' },
  { key: 'redisCoverageDeleted', label: 'Redis coverage' },
  { key: 'redisStreamLocksDeleted', label: 'Redis stream locks' },
];

export function ResetAgentDataPreview({ preview }: { preview: ResetResult }) {
  return (
    <>
      <div className="grid gap-3 sm:grid-cols-2">
        <DataScopeCard
          title="Kept"
          items={['Account row', 'Persona assignment', 'Story card mapping', 'Onboarding']}
        />
        <DataScopeCard
          title="Wiped"
          destructive
          items={[
            'Interview sessions',
            'Messages and card events',
            'Memories and swipe progress',
            'Mastra and Redis agent state',
          ]}
        />
      </div>

      <div className="overflow-hidden rounded-md border">
        <table className="w-full text-sm">
          <tbody>
            {countRows.map((row) => (
              <tr key={row.key} className="border-b last:border-b-0">
                <td className="px-3 py-2 text-muted-foreground">{row.label}</td>
                <td className="px-3 py-2 text-right font-medium text-foreground">
                  {preview.counts[row.key]}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

function DataScopeCard({
  title,
  items,
  destructive = false,
}: {
  title: string;
  items: string[];
  destructive?: boolean;
}) {
  return (
    <div className={cn('rounded-md border p-3', destructive && 'border-destructive/30')}>
      <p className={cn('font-medium', destructive ? 'text-destructive' : 'text-orb-teal')}>
        {title}
      </p>
      <ul className="mt-2 space-y-1 text-sm text-muted-foreground">
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  );
}
